import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError, AxiosResponse } from 'axios';
import { appAxios } from '@doda/common/src/libs/axios/appAxios';
import {
  ErrorResponseBody,
  PublicationPhotosResponse,
} from '@doda/api-client/aspida/@types';

// 企業公開写真一覧取得失敗時のエラーコード
export type GetCorporatePublishedPhotoErrorCode = 'NOT_FOUND';
export type CorporatePublishedPhotoError = ErrorResponseBody & {
  code: GetCorporatePublishedPhotoErrorCode | undefined;
};

/**
 * 企業公開写真一覧取得処理
 */
export const getCorporatePublishedPhotoUrlByCorporateClientId =
  createAsyncThunk<
    PublicationPhotosResponse,
    { corporateClientId: string; headers? },
    {
      rejectValue: CorporatePublishedPhotoError | undefined;
    }
  >('publicationPhoto/getByCorporateClientId', async (opt, thunkAPI) => {
    const { corporateClientId, headers } = opt;
    const url = `/api/v1/corporateClients/${corporateClientId}/publicationPhotos`;
    const publicationPhotosResponse = await appAxios({
      url,
      headers,
      params: {
        corporateClientId,
      },
    })
      .then((res: AxiosResponse<PublicationPhotosResponse>) => {
        return res.data;
      })
      .catch((error: AxiosError<CorporatePublishedPhotoError>) => {
        return thunkAPI.rejectWithValue(error.response?.data);
      });

    return publicationPhotosResponse;
  });

export type GetCorporatePublishedPhotoUrlByCorporateClientId = ReturnType<
  ReturnType<typeof getCorporatePublishedPhotoUrlByCorporateClientId>
>;
